import { render, staticRenderFns } from "./loginPage.vue?vue&type=template&id=4324fd6a&scoped=true"
import script from "./loginPage.vue?vue&type=script&lang=js"
export * from "./loginPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4324fd6a",
  null
  
)

export default component.exports